import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Real-time online presence. Subscribing announces this user online to their
// org; incoming join/leave deltas flip the `.is-online` class on any element
// tagged data-presence-user-id (the Messages sidebar teammate rows). A short
// heartbeat keeps the server-side presence key warm while the tab is open.
export default class extends Controller {
    connect() {
        if (typeof createConsumer !== "function") return
        try {
            this.consumer = createConsumer()
            this.subscription = this.consumer.subscriptions.create(
                { channel: "PresenceChannel" },
                {
                    received: (data) => this._onReceived(data),
                    connected: () => this._startHeartbeat()
                }
            )
        } catch (_error) {
            // Presence is a nicety; degrade silently if cable is unavailable.
        }
    }

    disconnect() {
        if (this._heartbeat) clearInterval(this._heartbeat)
        try {
            this.subscription?.unsubscribe()
            this.consumer?.disconnect()
        } catch (_error) {
            // ignore
        }
    }

    _onReceived(data) {
        if (!data || data.type !== "presence" || data.user_id == null) return
        const online = data.status === "online"
        document.querySelectorAll(`[data-presence-user-id="${data.user_id}"]`).forEach((row) => {
            row.classList.toggle("is-online", online)
        })
    }

    _startHeartbeat() {
        if (this._heartbeat) clearInterval(this._heartbeat)
        // Well inside the 3-minute Presence TTL.
        this._heartbeat = setInterval(() => {
            try { this.subscription?.perform("ping") } catch (_error) { /* ignore */ }
        }, 90000)
    }
}
